
import React from 'react';
import Layout from '@/components/Layout/Layout';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import OvulationCalculator from '@/components/SpecialCalculators/PregnancyCalculators/OvulationCalculator';

const OvulationCalculatorPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/special" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to Special Calculators
          </Link>
          <h1 className="text-3xl font-bold mb-2">Ovulation Calculator</h1>
          <p className="text-gray-600 mb-6">
            Find your most fertile days to increase your chances of getting pregnant.
          </p>
        </div>
        
        <div className="mb-8">
          <OvulationCalculator />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Ovulation</h2>
          <p>
            Ovulation is the release of an egg from one of your ovaries. It typically occurs about 
            midway through your menstrual cycle. Understanding when you ovulate can help you plan 
            for or avoid pregnancy.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Your Fertile Window</h3>
          <p>
            Your "fertile window" is the period during which you can become pregnant from unprotected sex. 
            This window includes:
          </p>
          <ul className="list-disc ml-6">
            <li>The 5 days before ovulation</li>
            <li>The day of ovulation itself</li>
          </ul>
          <p>
            This is because sperm can survive in the female reproductive tract for up to 5 days, 
            while an egg is typically viable for about 24 hours after ovulation.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Signs of Ovulation</h3>
          <p>
            In addition to using this calculator, you can look for physical signs of ovulation:
          </p>
          <ul className="list-disc ml-6">
            <li><strong>Changes in cervical mucus:</strong> It typically becomes clear, slippery, and stretchy, similar to egg whites.</li>
            <li><strong>Slight increase in basal body temperature:</strong> Your resting temperature rises slightly after ovulation.</li>
            <li><strong>Mild pelvic pain:</strong> Some women experience mittelschmerz, a slight pain when the egg is released.</li>
            <li><strong>Increased sex drive:</strong> Some women notice an increased libido around ovulation.</li>
            <li><strong>Changes in the cervix:</strong> The cervix becomes softer, higher, and more open during ovulation.</li>
          </ul>
          
          <div className="bg-green-50 p-4 rounded-md mt-6">
            <h3 className="text-lg font-medium text-green-800 mb-2">Improving Accuracy</h3>
            <p className="text-green-800">
              For more accurate ovulation tracking, consider using additional methods such as:
            </p>
            <ul className="list-disc ml-6 text-green-800">
              <li>Ovulation predictor kits (OPKs) that detect luteinizing hormone (LH) surge</li>
              <li>Basal body temperature (BBT) charting</li>
              <li>Fertility monitoring devices</li>
              <li>Tracking cervical mucus changes</li>
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default OvulationCalculatorPage;
